export default {
  // ActView
  act: 'Acta',
  typeOf: 'Tipo de {entity}',
  actType: 'Tipo de Acta',
  addNewAct: 'Agregar Nueva Acta',
  showActs: 'Mostrar Actas',
  createAct: 'Crear Acta',
  mustSelectActType: 'Debe seleccionar un Tipo de Acta.',
  mustSelectPeriod: 'Debe seleccionar un período específico para crear un acta.',
  from: 'de:',
  to: 'al:',

  // ActForm
  actCreatedSuccessfully: 'Acta creada.',
  actUpdatedSuccessfully: 'Acta actualizada.',

  // ActComponent
  guests: 'Invitados',
  identifier: 'Identificador',
  name: 'Nombre',
  email: 'Email',
  position: 'Cargo',
  otherInformation: 'Otra Información',
  user: 'Usuario',
  canEditAct: 'Puede Editar el Acta',
  createdBy: 'Creado por',
  noCreator: 'Usuario eliminado',
  attended: 'Asistió',
  external: 'Externo',
  internal: 'Interno',
  editAttendee: 'Editar Asistente',
  removeAttendee: 'Remover Asistente',
  manageAttendees: 'Gestionar Asistentes',
  addExternalAttendee: 'Agregar Asistente Externo',
  meetingTable: 'Tabla de Reunión',
  editAspect: 'Editar Aspecto',
  deleteAspect: 'Eliminar Aspecto',
  addAspect: 'Agregar Aspecto',
  treatedAspectsAndAgreements: 'ASPECTOS TRATADOS Y SUS ACUERDOS',
  comments: 'COMENTARIOS',
  comment: 'Comentario',
  addComment: 'Agregar Comentario',
  reloadComments: 'Recargar Comentarios.',
  commentsListUpdated: 'Lista de comentarios actualizados!',
  attachedFiles: 'ARCHIVOS ADJUNTOS',
  saveAct: 'Guardar Acta',
  createAspects: 'Crear Aspectos',
  createComment: 'Crear comentario',
  cannotSaveIfEmpty: 'No se puede guardar si está vacío.',
  deleteAspectConfirmation: '¿Está seguro de que desea remover el Aspecto?',
  deleteCommentConfirmation: '¿Está seguro de que desea remover el Comentario?',
  deleteFileConfirmation: '¿Está seguro de que desea remover el Archivo?',
  userAlreadyInList: 'El usuario seleccionado ya está en la lista.',
  deleteAttendeeConfirmation: '¿Está seguro de que desea remover al Asistente?',
  agreementDeleted: 'Acuerdo eliminado.',
  noComments: 'Aún no hay comentarios.',

  // SupportForm
  identifierType: 'Tipo de Identificador',
  firstName: 'Nombre',
  lastName: 'Apellidos',
  attendeeCreatedSuccessfully: 'Asistente creado.',
  attendeeUpdatedSuccessfully: 'Asistente actualizado.',

  // ActList
  noActsToShow: 'No hay Actas para mostrar.',
  actsList: 'Listado de {entity}',
  number: 'Número',
  agreements: 'Acuerdos',
  fulfilledAgreements: 'Acuerdos Cumplidos',
  totalAgreements: 'Total de Acuerdos',
  fulfilledTotals: 'Cumplidos / Totales',
  open: 'Abrir',
  deleteActConfirmation: '¿Está seguro de que desea eliminar el Acta?',
  actDeletedSuccessfully: 'Acta eliminada.',
  attachments: 'Adjuntos',
  noAttachments: 'Sin archivos adjuntos.',

  // ActFiles
  removeFile: 'Remover Archivo',
  selectOrDragFileHere: 'Seleccione o arrastre archivo aquí...',
  dragFileHere: 'Arrastre archivo aquí...',
  ensureUploadBeforeSave: 'Asegúrese de subir el Archivo antes de Guardar.',
  uploadFile: 'Subir Archivo',
  noAttachedFiles: 'No hay archivos adjuntos',

  // UserList
  typeToFilter: 'Escriba para filtrar',
  usersPerPage: 'Usuarios por página',
  typeToSearch: 'Escriba para buscar',
  professors: 'Profesores',
  students: 'Estudiantes',
  users: 'Usuarios',
  incorporate: 'Incorporar',

  // AspectAgreement
  addAgreement: 'Agregar Acuerdo',
  complianceDate: 'Fecha de Cumplimiento',
  agreement: 'Acuerdos',
  compliance: 'Cumplimiento',
  responsibles: 'Responsables',
  observations: 'Observaciones',
  editAgreement: 'Editar Acuerdo',
  deleteAgreement: 'Eliminar Acuerdo',
  createAgreement: 'Crear Acuerdo',
  agreementUpdated: 'Acuerdo actualizado.',
  deleteAgreementConfirmation: '¿Está seguro de que desea eliminar el Acuerdo?',

  // AspectAgreementForm
  agreementCreated: 'Acuerdo creado.',

  // ActComponent - Table fields
  role: 'Rol',

  // ActComponent - Messages
  superUser: 'Super Usuario',
  mustSelectAtLeastOneUser: 'Debe seleccionar al menos un usuario.',
}
